import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';

const TABS = [
  { id: 'clothing', label: 'Ready-to-Wear' },
  { id: 'shoes', label: 'Shoes' },
  { id: 'rings', label: 'Rings' },
];

const SizeGuide = () => {
  const [tab, setTab] = useState('clothing');

  return (
    <div>
      <PageHeader
        eyebrow="Size Guide"
        title="Find your fit."
        intro="Our pieces are cut generously and drape softly. Measurements below are of the garment itself; if you are between sizes, we always recommend sizing down for a cleaner line."
      />

      <section className="pb-32 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <Reveal>
            <div className="flex flex-wrap gap-1 border-b border-neutral-200 mb-10">
              {TABS.map((t) => (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  className={`px-6 py-4 text-[11px] tracking-[0.22em] uppercase transition-colors relative ${
                    tab === t.id ? 'text-neutral-900' : 'text-neutral-500 hover:text-neutral-900'
                  }`}
                >
                  {t.label}
                  {tab === t.id && <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-neutral-900" />}
                </button>
              ))}
            </div>
          </Reveal>

          <Reveal key={tab} delay={80} duration={800}>
            {tab === 'clothing' && <ClothingTable />}
            {tab === 'shoes' && <ShoesTable />}
            {tab === 'rings' && <RingsTable />}
          </Reveal>

          <Reveal delay={200}>
            <div className="mt-16 p-8 bg-[#fafaf8] border border-neutral-200">
              <h3 className="font-display text-xl font-medium mb-3">Need a personal fitting?</h3>
              <p className="text-sm text-neutral-600 leading-relaxed mb-5">
                Our client advisors can talk you through any silhouette by video call, free of charge. Book a
                time that works for you and we&rsquo;ll come to you.
              </p>
              <a
                href="mailto:andobreeofficial1@gmail.com?subject=Virtual%20fitting"
                className="inline-block text-[11px] tracking-[0.22em] uppercase border-b border-neutral-900 pb-1 hover:tracking-[0.26em] transition-all"
              >
                Book a Fitting
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

const Table = ({ head, rows }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left border-b border-neutral-300">
          {head.map((h) => (
            <th key={h} className="py-4 px-4 text-[11px] tracking-[0.22em] uppercase text-neutral-500 font-normal">
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className="border-b border-neutral-200 last:border-b-0">
            {r.map((c, j) => (
              <td key={j} className={`py-4 px-4 ${j === 0 ? 'font-medium text-neutral-900' : 'text-neutral-700'}`}>
                {c}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ClothingTable = () => (
  <Table
    head={['Size', 'EU', 'US', 'UK', 'Bust (cm)', 'Waist (cm)', 'Hip (cm)']}
    rows={[
      ['XS', '34', '2', '6', '82', '64', '90'],
      ['S', '36', '4', '8', '86', '68', '94'],
      ['M', '38', '6', '10', '90', '72', '98'],
      ['L', '40', '8', '12', '94', '76', '102'],
      ['XL', '42', '10', '14', '98', '80', '106'],
    ]}
  />
);

const ShoesTable = () => (
  <Table
    head={['EU', 'US', 'UK', 'Foot Length (cm)']}
    rows={[
      ['35', '5', '2.5', '22.5'],
      ['36', '6', '3.5', '23.0'],
      ['37', '7', '4.5', '23.5'],
      ['38', '8', '5.5', '24.2'],
      ['39', '9', '6.5', '24.8'],
      ['40', '10', '7.5', '25.4'],
      ['41', '11', '8.5', '26.0'],
    ]}
  />
);

const RingsTable = () => (
  <Table
    head={['Size', 'EU', 'US', 'Diameter (mm)']}
    rows={[
      ['XS', '48', '4.5', '15.3'],
      ['S', '51', '5.5', '16.1'],
      ['M', '54', '6.75', '17.2'],
      ['L', '57', '8', '18.1'],
      ['XL', '60', '9.25', '19.1'],
    ]}
  />
);

export default SizeGuide;
